import { Singleton } from '@denishussar/html5-game-engine';

export enum PropsSideEnum {
    left = 'left',
    forward = 'forward',
    right = 'right'
}

@Singleton
export class PropsModel {
    public step: number = 0;
    public stepMax: number = 5;
    public rightSides: string[] = [
        PropsSideEnum.left,
        PropsSideEnum.forward,
        PropsSideEnum.left,
        PropsSideEnum.right,
        PropsSideEnum.forward,
    ];

    constructor() {
    }

    public clear() {
        this.step = 0;
        this.stepMax = 5;
        this.rightSides = [
            PropsSideEnum.left,
            PropsSideEnum.forward,
            PropsSideEnum.left,
            PropsSideEnum.right,
            PropsSideEnum.forward,
        ];
    }
}
